import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const getAllPublicTable = (auctionFilter) => async (dispatch) => {
  dispatch({ type: "LOADING_PUBLIC" });
  try {
    const { data } = await auction.get(
      `/auction/read/all-public-auctions?${
        auctionFilter && "auctionType=" + auctionFilter
      }`
    );

    dispatch({ type: "ALL_PUBLIC_TABLE", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "LOADDED_PUBLIC" });
  }
};

export const getTodayPublicTable =
  (auctionFilter, setTodayData) => async (dispatch) => {
    dispatch({ type: "LOADING_PUBLIC" });
    try {
      const { data } = await auction.get(
        `/auction/read/today-public-auctions?${
          auctionFilter && "auctionType=" + auctionFilter
        }`
      );

      dispatch({ type: "TODAY_PUBLIC_TABLE", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      setTodayData([]);
      dispatch({ type: "LOADDED_PUBLIC" });
    }
  };

export const getUpcommingPublicTable = (auctionFilter) => async (dispatch) => {
  dispatch({ type: "LOADING_PUBLIC" });
  try {
    const { data } = await auction.get(
      `/auction/read/upcoming-public-auctions?${
        auctionFilter && "auctionType=" + auctionFilter
      }`
    );

    dispatch({ type: "UPCOMMING_PUBLIC_TABLE", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "LOADDED_PUBLIC" });
  }
};
